module.exports = __webpack_public_path__ + "media/ad_designs/espn-ad-placement-b0830811.jpg";